import keyBy from "lodash/keyBy";
import moment from "moment";
export const defaultBudget = {
  "54c9ae71-d868-41cb-b1e7-02ad24542a1c": 1000,
  "54c9ae72-d868-41cb-b1e7-02ad24542a1c": 2000,
  "54c9ae73-d868-41cb-b1e7-02ad24542a1c": 8000,
  "54c9ae74-d868-41cb-b1e7-02ad24542a1c": 18000,
  "54c9ae75-d868-41cb-b1e7-02ad24542a1c": 32000,
  "54c9ae76-d868-41cb-b1e7-02ad24542a1c": 50000,
  "54c9ae77-d868-41cb-b1e7-02ad24542a1c": 72000,
};

export const campaignItems = [
  "54c9ae71-d868-41cb-b1e7-02ad24542a1c",
  "54c9ae72-d868-41cb-b1e7-02ad24542a1c",
  "54c9ae73-d868-41cb-b1e7-02ad24542a1c",
  "54c9ae74-d868-41cb-b1e7-02ad24542a1c",
  "54c9ae75-d868-41cb-b1e7-02ad24542a1c",
  "54c9ae76-d868-41cb-b1e7-02ad24542a1c",
  "54c9ae77-d868-41cb-b1e7-02ad24542a1c",
].map((showUUID, i) => ({
  uuid: showUUID,
  showUUID,
  campaignUUID: "df0a2239-b2fb-4de9-a908-83a8d804acd9",
  state: i < 3 ? "running" : "sent",
  mediaFileUUID: "a9a558fc-6f73-4674-8510-319167bbcc10",
  sentAt: moment()
    .subtract(i, "d")
    .unix(),
}));

export const FakeShows = keyBy(
  [
    "54c9ae71-d868-41cb-b1e7-02ad24542a1c",
    "54c9ae72-d868-41cb-b1e7-02ad24542a1c",
    "54c9ae73-d868-41cb-b1e7-02ad24542a1c",
    "54c9ae74-d868-41cb-b1e7-02ad24542a1c",
    "54c9ae75-d868-41cb-b1e7-02ad24542a1c",
    "54c9ae76-d868-41cb-b1e7-02ad24542a1c",
    "54c9ae77-d868-41cb-b1e7-02ad24542a1c",
  ].map((uuid, i) => ({
    uuid: uuid,
    userUUID: "5cb9eec5-84d0-48b2-964b-e0b2004d36b6",
    title: "Babcock",
    link: "http://podiobooks.com/title/babcock",
    description: "asdf",
    summary: "",
    subtitle: "",
    imageMediaFileUUID: "f457b504-9671-4b46-85c8-c550b58cd712",
    language: "en",
    copyright: "All rights reserved.",
    isComplete: false,
    isVisible: true,
    isExplicit: false,
    ownerEmail: "noreply@getredcircle.com",
    ownerName: "Joe Cottonwood",
    categoryUUIDs: [
      "00917086-bacc-4e01-9f94-eefcff96b8dd",
      "51d73fa8-4662-4236-89e1-585fea4a6eb6",
      "c274d8e6-a37b-4c0b-826d-18ffb35adb6f",
    ],
    createdAt: 1547074481,
    updatedAt: 1547074481,
    importedURL: "",
    autoImportBitrate: 128,
    shouldAutoImport: false,
    shouldRedirectNewEpisodes: true,
    estimatedWeeklyDownloads: (i + 1) * 7000,
    advertisementSettings: {
      hostReadPreRollCPM: (i + 1) * 1000,
      hostReadMidRollCPM: (i + 1) * 1000,
      hostReadPostRollCPM: (i + 1) * 1000,
      preRecordedPreRollCPM: (i + 1) * 1000,
      preRecordedMidRollCPM: (i + 1) * 1000,
      preRecordedPostRollCPM: (i + 1) * 1000,
    },
  })),
  "uuid"
);
